import { createFileRoute } from "@tanstack/react-router";
import { PrayerHome } from "@/components/prayer/PrayerHome";

export const Route = createFileRoute("/jadwal-sholat/")({
  head: () => ({
    meta: [
      { title: "Jadwal Sholat Hari Ini Seluruh Indonesia - hari.co.id" },
      { name: "description", content: "Jadwal sholat lima waktu untuk seluruh kota di Indonesia: Imsak, Subuh, Terbit, Dhuha, Dzuhur, Ashar, Maghrib, Isya. Otomatis sesuai lokasi Anda atau pilih provinsi/kota." },
      { property: "og:title", content: "Jadwal Sholat Indonesia" },
      { property: "og:description", content: "Jadwal sholat akurat untuk setiap kota dan kecamatan di Indonesia." },
      { property: "og:url", content: "https://hari.co.id/jadwal-sholat/" },
      { property: "og:image", content: "https://hari.co.id/og-jadwal-sholat.svg" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: "https://hari.co.id/og-jadwal-sholat.svg" },
      { name: "robots", content: "index, follow, max-image-preview:large" },
    ],
    links: [{ rel: "canonical", href: "https://hari.co.id/jadwal-sholat/" }],
  }),
  component: () => <PrayerHome variant="sholat" />,
});